
export const SidebarLogo = () => {
  return (
    <div className="p-4 border-b border-white/10 h-[72px] flex items-center">
      {/* Space reserved to ensure sidebar content doesn't go under the header */}
    </div>
  );
};
